module.exports = __webpack_public_path__ + "static/tools-resources-hero@2x-5c0f0123daaabb36a92d32b60c9797c7.jpg";